/*
  IW Nuevo: custom label and icon for the Shopify Inbox chat button.
  The app only offers fixed labels ("Chat") and a "team" icon, so both are rewritten inside the open shadow root of
  <shopify-chat> (the speech-bubble icon is the app's own "chat" icon).
  If the app markup changes, the selector misses and the stock label stays: nothing breaks.
*/
(function () {
  var LABEL = 'Habla con Nicolás';
  var ARIA = LABEL + '. Abrir chat';
  var ICON = 'chat';

  function apply() {
    var host = document.querySelector('shopify-chat');
    var runtime = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = runtime && runtime.shadowRoot;
    var label = root && root.querySelector('.activator__label');
    if (!label) return false;
    if (label.textContent !== LABEL) label.textContent = LABEL;
    var icon = root.querySelector('.activator shopify-chat-icon');
    if (icon && icon.getAttribute('name') !== ICON) icon.setAttribute('name', ICON);
    var button = label.closest('button');
    if (button && button.getAttribute('aria-label') !== ARIA) button.setAttribute('aria-label', ARIA);
    return root;
  }

  var tries = 0;
  var timer = setInterval(function () {
    var root = apply();
    if (root) {
      clearInterval(timer);
      new MutationObserver(apply).observe(root, { childList: true, subtree: true, characterData: true });
    } else if (++tries > 40) {
      clearInterval(timer);
    }
  }, 500);
})();
